import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Snackbar,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  AccountBalanceWallet as WalletIcon,
  AdminPanelSettings as AdminIcon,
  Logout as LogoutIcon,
  ManageAccounts as ManageIcon,
} from '@mui/icons-material';
import { useAccess } from '../context/AccessContext';

const compactAddress = (address) => (
  address ? `${address.slice(0, 6)}...${address.slice(-4)}` : ''
);

export default function AccessIdentityControl() {
  const { identity, authenticating, connectWallet, logout, error, clearError } = useAccess();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleConnect = async () => {
    try {
      await connectWallet();
    } catch {
      // Context exposes the user-facing error.
    }
  };

  const label = identity?.role === 'admin'
    ? identity.username
    : compactAddress(identity?.address);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {identity ? (
          <Button
            color="inherit"
            variant="outlined"
            startIcon={identity.role === 'admin' ? <AdminIcon /> : <WalletIcon />}
            onClick={(event) => setAnchorEl(event.currentTarget)}
            sx={{
              height: 38,
              minWidth: 0,
              borderColor: 'rgba(255,255,255,0.22)',
              color: 'text.primary',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </Button>
        ) : (
          <Button
            color="inherit"
            variant="outlined"
            startIcon={authenticating ? <CircularProgress size={16} color="inherit" /> : <WalletIcon />}
            onClick={handleConnect}
            disabled={authenticating}
            sx={{
              height: 38,
              borderColor: 'rgba(255,255,255,0.22)',
              color: 'text.primary',
              whiteSpace: 'nowrap',
            }}
          >
            Web3 登入
          </Button>
        )}

        <Tooltip title="權限管理">
          <IconButton
            component={Link}
            to="/admin"
            color="inherit"
            aria-label="權限管理"
            sx={{ border: '1px solid rgba(255,255,255,0.16)' }}
          >
            <ManageIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ sx: { minWidth: 230 } }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="caption" color="text.secondary">
            {identity?.role === 'admin' ? '管理員' : '身分錢包'}
          </Typography>
          <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
            {identity?.username || identity?.address}
          </Typography>
        </Box>
        {identity?.role === 'admin' && (
          <MenuItem component={Link} to="/admin" onClick={() => setAnchorEl(null)}>
            <ListItemIcon><ManageIcon fontSize="small" /></ListItemIcon>
            權限管理
          </MenuItem>
        )}
        <MenuItem onClick={() => { setAnchorEl(null); logout(); }}>
          <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
          登出
        </MenuItem>
      </Menu>

      <Snackbar open={Boolean(error)} autoHideDuration={6000} onClose={clearError}>
        <Alert severity="error" onClose={clearError} variant="filled">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
}
